module.exports = __webpack_public_path__ + "static/media/pic-ht4.b10c1e79.jpg";